// extracted by mini-css-extract-plugin
export default {"font-renta":"NotificationsPanel_font-renta__9jm6U"};